import { AfterViewInit, Component, Injector, OnDestroy, ViewChild } from '@angular/core';
import { DocumentEditItemBase } from '../edit-item-base';
import {
    DocumentEditItemSimpleTextPanelComponent,
    DocumentEditItemSimpleTextPanelComponentData,
    IDocumentEditItemSimpleTextPanelComponentData,
} from '../simple-text-panel/simple-text-panel.component';
import { DocumentPanelRootService } from '../../document-panel-root/document-panel-root.service';

@Component({
    selector: 'fi-document-edit-item-simple-text',
    template: '',
    styleUrls: ['./simple-text.component.scss'],
    standalone: false,
})
export class DocumentEditItemSimpleTextComponent extends DocumentEditItemBase implements AfterViewInit, OnDestroy {
    constructor(
        injector: Injector,
        public documentPanelRootService: DocumentPanelRootService,
    ) {
        super(injector);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const simpleTextPanelComponentData: IDocumentEditItemSimpleTextPanelComponentData = {
                componentElement: this.elementRef.nativeElement,
            };
            const panelInjector = Injector.create({
                providers: [
                    {
                        provide: DocumentEditItemSimpleTextPanelComponentData,
                        useValue: simpleTextPanelComponentData,
                    },
                ],
                parent: this.injector,
            });

            this.documentPanelRootService.setPanel(DocumentEditItemSimpleTextPanelComponent, panelInjector, this);
        });
    }

    ngOnDestroy() {
        setTimeout(() => {
            if (this.documentPanelRootService.editComponent === this)
                this.documentPanelRootService.setPanel(null, null, null);
        });
    }
}
